import { render, staticRenderFns } from "./ProjectTaskTable.vue?vue&type=template&id=9b3bd898&scoped=true&"
import script from "./ProjectTaskTable.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTaskTable.vue?vue&type=style&index=0&id=9b3bd898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3bd898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b3bd898')) {
      api.createRecord('9b3bd898', component.options)
    } else {
      api.reload('9b3bd898', component.options)
    }
    module.hot.accept("./ProjectTaskTable.vue?vue&type=template&id=9b3bd898&scoped=true&", function () {
      api.rerender('9b3bd898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectTaskTable.vue"
export default component.exports